import { defineStore } from "pinia"
import { ref } from "vue"

export const useLeaveAppModalStore = defineStore("leaveAppModal", () => {
  const isActive = ref(false)

  return {
    isActive,
  }
})
